// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2tga5","gfeWrapper":"CalendarEvent_gfeWrapper__HCjW8"};